import fetchServer from "../../../fetchServer";

/**
 * POST /product/v1/changeBooking/declineBySupplier/:id
 * Admin records that the airline/supplier declined a date change, details
 * change, or open ticket. Body: { reason, supplierResponseCode?, supplierResponse? }
 */
export default async function declineChangeBySupplier(id, data) {
  var result = {
    return: 0,
    msg: "Something went wrong recording supplier decline",
    data: [],
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/changeBooking/declineBySupplier/${id}`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res.status === 201) {
          result = {
            return: 1,
            msg: "Successfull",
            data: res.data?.data,
            warning: res.data?.warning || res.data?.data?.warning,
          };
        } else if (res?.data?.error) result["msg"] = res.data.error;
        else if (res?.data?.message) result["msg"] = res.data.message;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
